/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components, getter-return, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { computed } from '@ember/object';
import { or, filter } from '@ember/object/computed';
import { service } from '@ember/service';
import moment from 'moment';
import { isEmpty } from '@ember/utils';

export default class AssessmentsOverview extends Component {
  // Services
  @service
  store;

  @service
  terms;

  // Props
  // numTermsToShow specifies the number of terms data to load.
  @tracked numTermsToShow = 8;

  // person provides the person model to display an assessment overview for.
  person = null;

  // State
  @tracked
  loadingAssessments = true;

  @tracked
  loadingModules = true;
  @tracked
  loadingGrades = true;

  @or('loadingAssessments', 'loadingModules', 'loadingGrades')
  loading;

  @filter('grades', ['dateFrom'], function (grade) {
    if (isEmpty(this.dateFrom)) {
      return false;
    }
    return grade.createTime >= this.dateFrom;
  })
  recentGrades;

  @tracked
  assessments;

  @tracked
  grades;

  @tracked
  modules;

  @computed('terms.currentTerm', 'numTermsToShow')
  get dateFrom() {
    let term = this.terms.currentTerm;
    if (isEmpty(term)) {
      return;
    }
    let termCount = 1;
    while (termCount < this.numTermsToShow) {
      if (!isEmpty(term.get('previous.term'))) {
        term = term.get('previous');
      } else {
        break;
      }
      termCount++;
    }
    return moment(term.get('start'), 'YYYY-MM-DD').unix();
  }

  init() {
    super.init(...arguments);
    let store = this.store;
    store.findAll('assessments/assessment').then((assessments) => {
      this.assessments = assessments;
      this.loadingAssessments = false;
    });
    store
      .query('assessments/module', { include: 'gradeSchedules' })
      .then((modules) => {
        this.modules = modules;
        this.loadingModules = false;
      });
    store
      .query('assessments/grade', { personId: this.get('person.id') })
      .then((grades) => {
        this.grades = grades;
        this.loadingGrades = false;
      });
  }
}
